import type {WaterfallSourceAdapter} from './types.ts';

const adapters = new Map<string, WaterfallSourceAdapter>();

export function registerWaterfallSource(adapter: WaterfallSourceAdapter): void {
    const id = String(adapter?.sourceId || '').trim();
    if (!id) {
        throw new Error('registerWaterfallSource: sourceId required');
    }
    adapters.set(id, adapter);
}

export function getWaterfallSource(sourceId: string): WaterfallSourceAdapter | undefined {
    return adapters.get(String(sourceId || '').trim());
}

export function listSupportedSourceIds(): string[] {
    return [...adapters.keys()];
}

export function isSupportedWaterfallSource(sourceId: string): boolean {
    return adapters.has(String(sourceId || '').trim());
}

export function resetWaterfallSourceRegistryForTests(): void {
    adapters.clear();
}
